import React, { createContext, useContext, useState, ReactNode } from 'react';

type Version = 'A' | 'B' | 'C';

interface VersionContextType {
  version: Version;
  setVersion: (version: Version) => void;
  toggleVersion: () => void;
}

const VersionContext = createContext<VersionContextType | undefined>(undefined);

export const useVersion = () => {
  const context = useContext(VersionContext);
  if (context === undefined) {
    throw new Error('useVersion must be used within a VersionProvider');
  }
  return context;
};

interface VersionProviderProps {
  children: ReactNode;
}

export const VersionProvider: React.FC<VersionProviderProps> = ({ children }) => {
  const [version, setVersion] = useState<Version>('A');

  const toggleVersion = () => {
    setVersion(prev => {
      if (prev === 'A') return 'B';
      if (prev === 'B') return 'C';
      return 'A';
    });
  };

  return (
    <VersionContext.Provider value={{ version, setVersion, toggleVersion }}>
      {children}
    </VersionContext.Provider>
  );
};